import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {actions, selectors} from '../../Redux/index';
import {NavLink, Link} from 'react-router-dom';
import Icon from '../../Components/Helper/Icon';
import {i18n, i18nString} from '../../Utility/Format';
import PanelToggleButton from '../../Components/Controls/PanelToggleButton'; 
import Backdrop from '../../Components/Helper/Backdrop';
import DrawerPanel, {
    DrawerPanelPanel,
    DrawerPanelPanelHeader,
    DrawerPanelPanelContent
} from '../../Components/Helper/DrawerPanel';
import dbLogo from '../../Resources/Images/db_logo.svg';
import dbIdentifier from '../../Resources/Images/db_identifier.svg';
import ApplicationHeader from '../../Components/Content/ApplicationHeader';
import {executeWebtrekkMapp} from '../../Utility/Webtrekk/WebtrekkMapp';

/**
 * The main menu of the application displayed as a `DrawerPanel`.
 * Can be oppened an closed with the `MainMenuToggle`.
 */
const MainMenuPanel = (props) => { 

    const renderCircledChevron = () => {
        return <Icon name="menu-item-filled" isCollapsed={true}/>
    };

    const renderChevron = () => {
        return <Icon name="menu-item" isCollapsed={true}/>
    };

    const renderPanelHeader = () => {
        return (
            <DrawerPanelPanelHeader>
                <ApplicationHeader
                    className="u-breakpoint--hideForMobile"
                    left={<PanelToggleButton icon="close" onClick={props.onToggle} label={i18n('dbm.button.close')}/>}
                />
                <ApplicationHeader
                    className="u-breakpoint--mobileOnly"
                    left={<PanelToggleButton icon="close" onClick={props.onToggle}/>}
                    right={<img className="u-brandLogo" src={dbLogo} alt="Deutsche Bank Logo"/>}
                    middle={<img className="u-brandIdentifier" src={dbIdentifier} alt="DB Markets"/>}
                />
            </DrawerPanelPanelHeader>
        )
    };

    const isGerman = props.language === 'de';

    return (
        <DrawerPanel onClick={props.onClose} isOpen={props.isOpen}>
            <DrawerPanelPanel>
                { renderPanelHeader(props.currentBreakpoint) }
                <DrawerPanelPanelContent>
                    <nav onClick={props.onClose}  role="navigation">
                        <ul className="main-menu">
                            <li> 
                                <NavLink to="/" end>
                                    {i18n('dbm.stage.nav.home', 'Home')} {renderCircledChevron()}
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/settlement">
                                    {i18n('dbm.stage.nav.settlement', 'Abrechnung')} {renderCircledChevron()}
                                </NavLink></li>
                            <li>
                                <NavLink to="/spot">
                                    {i18n('dbm.stage.nav.spot', 'Spot')} {renderCircledChevron()}
                                </NavLink></li>
                            <li>
                                <NavLink to="/forward">
                                    {i18n('dbm.stage.nav.forward', 'Forward')} {renderCircledChevron()}
                                </NavLink>
                            </li>
                            <li className="secondary">
                                <Link to="/pages/api">
                                    {i18n('dmb.links.api')} {renderChevron()}
                                </Link>
                            </li>
                             {/* To map an external DB website */}
                            { isGerman ?
                                <li className="secondary"> 
                                <a href={i18nString('dmb.links.taxDisclaimer.href', props.language)} target="_blank" rel="noopener noreferrer" onClick={executeWebtrekkMapp}>
                                    {i18n('dmb.links.taxDisclaimer')} {renderChevron()}
                                </a> 
                                </li> : null 
                            }
                                                          

                            <li className="secondary">
                                <a href={i18nString('dmb.links.imprint.href', props.language)} target="_blank" rel="noopener noreferrer">
                                    {i18n('dmb.links.imprint')} {renderChevron()}
                                </a>
                            </li>
                            <li className="secondary">
                                <NavLink to="/pages/terms-of-use">
                                    {i18n('dmb.links.termsOfUse')} {renderChevron()} 
                                </NavLink>
                            </li>
                            <li className="secondary">
                                <NavLink to="/pages/privacy-statement">
                                    {i18n('dmb.links.privacyStatement')} {renderChevron()}
                                </NavLink>
                            </li>
                            <li className="secondary"> 
                                <a href={i18nString('dmb.links.deutscheBank.href', props.language)} target="_blank" rel="noopener noreferrer">
                                    {i18n('dmb.links.deutscheBank')} {renderChevron()}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </DrawerPanelPanelContent>
            </DrawerPanelPanel>
            <Backdrop onClick={props.onClose}/>
        </DrawerPanel>
    );
};

MainMenuPanel.propTypes = {
    className: PropTypes.string
};

/**
 * Control for toggeling the `MainMenuPanel` from anywhere in the application
 */ 
const MainMenuToggle = (props) => {
    if (props.currentBreakpoint === 'mobile') {
        return <PanelToggleButton className="main-menu-toggle" icon="menu" onClick={props.onToggle} aria-label={i18n('dbm.button.menu')}/>
    }

    return <PanelToggleButton className="main-menu-toggle" icon="menu" onClick={props.onToggle}
                              label={i18n('dbm.button.menu')} aria-label={i18nString('dbm.button.menu',props.language)}/>
};

MainMenuToggle.propTypes = {
    onToggle: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => {
    return {
        onToggle: () => {
            dispatch(actions.UI.MainMenu.toggle());
        },

        onClose: () => {
            dispatch(actions.UI.MainMenu.close());
        }
    }
};

const mapStateToProps = (state) => {
    return {
        isOpen: selectors.UI.MainMenu.isOpen(state),
        language: selectors.UI.Locale.getLocale(state)
    };
};

const _MainMenuPanel = connect(mapStateToProps, mapDispatchToProps)(MainMenuPanel);

const _MainMenuToggle = connect(mapStateToProps, mapDispatchToProps)(MainMenuToggle);

export default _MainMenuPanel;
export {_MainMenuToggle as MainMenuToggle};